export const SET_POPUP = 'SET_POPUP';
export const RESET_POPUP = 'RESET_POPUP';
